import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/Button';

export const Navbar: React.FC = () => {
    const [scrolled, setScrolled] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 50);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToContact = () => {
        const contactSection = document.getElementById('contact');
        if (contactSection) {
            contactSection.scrollIntoView({ behavior: 'smooth' });
        }
        setMobileOpen(false);
    };

    const navLinks = [
        { name: 'About', href: '#about' },
        { name: 'Process', href: '#process' },
        { name: 'Facilities', href: '#facilities' },
        { name: 'Pricing', href: '#pricing' },
        { name: 'FAQ', href: '#faq' },
    ];

    return (
        <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/95 backdrop-blur-md py-4 shadow-sm' : 'bg-transparent py-6'}`}>
            <div className="container mx-auto px-6 flex items-center justify-between">
                <a href="#" className={`text-xl md:text-2xl font-bold tracking-tighter ${scrolled ? 'text-black' : 'text-black md:text-white'} z-50 relative`}>
                    <img src="/logo.png" alt="GoLengthening" className="h-16 w-auto" />
                </a>

                {/* Desktop Nav */}
                <div className="hidden md:flex items-center space-x-8">
                    {navLinks.map((link) => (
                        <a 
                            key={link.name} 
                            href={link.href} 
                            className={`text-sm font-medium hover:text-[#11BC97] transition-colors ${scrolled ? 'text-gray-700' : 'text-white/90 hover:text-white'}`}
                        >
                            {link.name}
                        </a>
                    ))}
                    <Button 
                        variant={scrolled ? 'primary' : 'white'} 
                        className="text-sm px-6 py-2"
                        onClick={scrollToContact}
                    >
                        Book Consultation
                    </Button>
                </div>

                {/* Mobile Toggle */}
                <button 
                    className="md:hidden z-50 relative p-2 focus:outline-none"
                    onClick={() => setMobileOpen(!mobileOpen)}
                >
                    {mobileOpen ? (
                        <X className="text-black" />
                    ) : (
                        <Menu className={scrolled ? 'text-black' : 'text-black md:text-white'} />
                    )}
                </button>

                {/* Mobile Nav Overlay */}
                <div className={`fixed inset-0 bg-white z-40 flex flex-col items-center justify-center space-y-8 transition-transform duration-300 ease-in-out md:hidden ${mobileOpen ? 'translate-x-0' : 'translate-x-full'}`}>
                    {navLinks.map((link) => (
                        <a 
                            key={link.name} 
                            href={link.href}
                            onClick={() => setMobileOpen(false)}
                            className="text-3xl font-medium text-black hover:text-[#11BC97] transition-colors"
                        >
                            {link.name}
                        </a>
                    ))}
                     <Button 
                        onClick={scrollToContact} 
                        className="text-lg px-8 py-3"
                    >
                        Book Consultation
                    </Button>
                </div>
            </div>
        </nav>
    );
};